module.exports = __webpack_public_path__ + "static/media/sistema-manager.d586bc6b.jpg";